import type { Country } from "@/models/countries"

const availableLanguages = process.env.VUE_APP_AVAIALABLE_LANGUAGES
  ? process.env.VUE_APP_AVAIALABLE_LANGUAGES.split(",")
  : ["hu", "en"].map((language: string) => language.trim())

const countryNames = Object.fromEntries(
  availableLanguages.map((language: string) => [
    language,
    new Intl.DisplayNames([language], { type: "region" })
  ])
)

export const getCountryName = (country: Country, locale: string): string => {
  const language =
    availableLanguages.find((language: string) =>
      locale.startsWith(language)
    ) || availableLanguages[0]

  return countryNames[language]?.of(country.code) || country.code
}
